import r from "./_createCompounder.js";
var t = r(function(e, a, o) {
  return e + (o ? "-" : "") + a.toLowerCase();
});
const s = t;
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/kebabCase.js
// module id = 1567
// module chunks = 67